import type { TQualityBand } from 'partner360/components/qualityIndicator'
import { TRANSLATION_KEYS as QUALITY_KEYS } from 'partner360/components/qualityIndicator/configs/translations'

import type { ICockpitExportPillar } from '../../../api'

/** What a pillar card shows in place of a score it does not have — `QualityPillar`'s own mark. */
export const NO_PILLAR_SCORE = '—'

/**
 * A pillar card's score with its Tag and progress bar, as `QualityPillar` and
 * `FinancialPlanQualityPillar` draw them: one band colours both the Tag and the bar, and the Tag
 * reads that band's name. A card with no score shows its mark alone, without Tag or bar.
 */
export const getPillarScore = (
  score: number | null,
  band: TQualityBand | null,
  translate: (key: string) => string
): Pick<ICockpitExportPillar, 'score' | 'band' | 'bandLabel' | 'progress'> =>
  score === null || band === null
    ? { score: NO_PILLAR_SCORE, progress: score ?? undefined }
    : {
        score: `${score}%`,
        band,
        bandLabel: translate(QUALITY_KEYS.tag[band]),
        progress: score,
      }
